import UploadFiles from "./UploadFiles";

export default UploadFiles;
